<template>
  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="table-light">
        <tr>
          <slot name="head" />
        </tr>
      </thead>

      <tbody>
        <template v-for="row in items" :key="getRowKey(row)">
          <slot
            name="row"
            :row="row"
            :rowKey="getRowKey(row)"
            :isExpanded="isExpanded(getRowKey(row))"
            :toggleExpand="() => $emit('toggle-expand', getRowKey(row))"
          />

          <tr v-if="hasExpandedSlot && isExpanded(getRowKey(row))">
            <td :colspan="expandedColspan">
              <slot name="expandedRow" :row="row" :rowKey="getRowKey(row)" />
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { computed, useSlots, defineProps, defineEmits } from "vue";

const props = defineProps({
  items: { type: Array, default: () => [] },
  getRowKey: { type: Function, required: true },
  expandedKeys: { type: Object, default: null }, // ideálně Set
  expandedColspan: { type: Number, default: 1 },
});

defineEmits(["toggle-expand"]);

const slots = useSlots();
const hasExpandedSlot = computed(() => !!slots.expandedRow);

const isExpanded = (key) => {
  if (!props.expandedKeys) return false;
  if (props.expandedKeys instanceof Set) return props.expandedKeys.has(key);
  if (Array.isArray(props.expandedKeys)) return props.expandedKeys.includes(key);
  return false;
};
</script>

<style scoped>
</style>
